import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { AnalyticsService } from '../services/analytics/analytics.service';
import { ProductManagerService } from 'catalean-provider';

@Injectable({
	providedIn: 'root',
})
export class AnalyticsGuard implements CanActivate {

  productManager = inject(ProductManagerService);

	constructor(private analyticsService: AnalyticsService) {}

	canActivate(_route: ActivatedRouteSnapshot, state: RouterStateSnapshot): true {
    if (!state.url.includes('tab-')) {
      const uuidMatch = state.url.match(/[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}/i)
      const productId = uuidMatch?.[0];
      const product =this.productManager.getProduct(productId);
      const event = state.url.replace(productId, product?.name ?? productId);

		  this.analyticsService.trackNavigation(event);
    }
		return true;
	}
}
